<template>
	<v-card
		class="product-card"
		:elevation="shadow ? 1 : 0"
		:outlined="outlined ? true : false"
		:width="width">
		<v-card-text class="product-card__body">
			<div class="product-card__image-wrap">
				<!-- <h3 class="red--text hot-blink" style="position: absolute; right: 2px">
          Popular
        </h3> -->
				<img
					class="image-preview"
					loading="lazy"
					:src="getProductPictureUrlById(product.pictureId)" />
			</div>
			<div class="product-card__title">
				<a
					class="product-card__title-link primary--text"
					@click="
						if (clickable)
							$router.push({
								name: 'ProductDetail',
								params: { id: product.id },
							});
					">
					{{ product.title }}
				</a>
			</div>
			<div v-if="showQty" class="product-card__stats">
				<div class="product-card__stat">
					<span>US</span>
					<strong>{{ product.usQuantity || 0 }}</strong>
				</div>
				<div class="product-card__stat">
					<span>VN</span>
					<strong>{{ product.vnQuantity || 0 }}</strong>
				</div>
				<div class="product-card__stat">
					<span>Total</span>
					<strong>{{ product.quantity || 0 }}</strong>
				</div>
				<div class="product-card__stat">
					<span>Hold</span>
					<strong>{{ product.placeHolderQuantity || 0 }}</strong>
				</div>
			</div>
			<div v-if="showPrice" class="product-card__prices">
				<div class="product-card__price-row">
					<div class="product-card__price">
						<span>Retail</span>
						<strong>
							${{ convertToCleanNumber(product.retailPrice) }}
						</strong>
					</div>
					<div class="product-card__price">
						<span>Discount</span>
						<strong>
							${{ convertToCleanNumber(product.discount) }}
						</strong>
					</div>
					<div class="product-card__price">
						<span>Sale</span>
						<strong>
							${{ convertToCleanNumber(product.salePrice) }}
						</strong>
					</div>
				</div>
				<div class="product-card__cost-grid">
					<div class="product-card__cost">
						<span>Air</span>
						<strong>
							{{ getCurrencySymbol(product.currencyId) }}{{
								convertToCleanNumber(
									product.airPrice,
									getCurrencySymbol(product.currencyId) == "$"
								)
							}}
						</strong>
					</div>
					<div class="product-card__cost">
						<span>Container</span>
						<strong>
							{{ getCurrencySymbol(product.containerCurrencyId)
							}}{{ convertToCleanNumber(
								product.containerPrice,
								getCurrencySymbol(product.containerCurrencyId) == "$"
							) }}
						</strong>
					</div>
					<div class="product-card__cost">
						<span>Unit</span>
						<strong>
							{{ getCurrencySymbol(product.currencyId) }}{{
								convertToCleanNumber(
									product.unitPrice,
									getCurrencySymbol(product.currencyId) == "$"
								)
							}}
						</strong>
					</div>
				</div>
			</div>
		</v-card-text>
		<v-card-actions v-if="allowAddToCart" class="product-card__actions">
			<v-btn
				block
				rounded
				depressed
				color="primary"
				:loading="isLoading"
				@click="addToCart(product)">
				<v-icon left small>mdi-cart-plus</v-icon>
				Add to Cart
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import backendService from "@/services/backend-service";
import eventBus from "@/js/event-bus";
import generalMixin from "@/js/general-mixin";
export default {
	name: "ProductCard",
	mixins: [generalMixin],
	props: {
		showQty: {
			type: Boolean,
			default: false,
		},
		showPrice: {
			type: Boolean,
			default: true,
		},
		allowAddToCart: {
			type: Boolean,
			default: false,
		},
		product: {
			type: Object,
			default: () => {
				return {};
			},
		},
		clickable: {
			type: Boolean,
			default: true,
		},
		outlined: {
			type: Boolean,
			default: true,
		},
		shadow: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: "500px",
		},
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		cart() {
			return this.$store.getters["cart"];
		},
		cartCount() {
			return this.$store.getters["cartCount"];
		},
	},
	methods: {
		getProductPictureUrlById(imageId) {
			return backendService.getProductPictureUrlById(imageId);
		},
		addToCart() {
			let cart = this.cart;
			let cartCount = this.cartCount;
			if (!cart[this.product.id]) {
				let item = { product: this.product, count: 0 };
				this.$set(cart, this.product.id, item);
			}
			cart[this.product.id].count += 1;
			this.$store.commit("setCart", cart);
			this.$store.commit("setCartCount", cartCount + 1);

			localStorage.setItem("cartCount", cartCount + 1);
			localStorage.setItem("cart", JSON.stringify(cart));

			this.isLoading = true;
			this.timer(1000).then(() => {
				this.isLoading = false;
				eventBus.$emit(
					"setSnackbar",
					"Item added to the cart",
					"success",
					true
				);
			});
		},
	},
};
</script>
<style scoped>
.product-card {
	border-color: #e0e6ed;
	border-radius: 8px;
	overflow: hidden;
	transition: box-shadow 160ms ease, transform 160ms ease,
		border-color 160ms ease;
}
.product-card:hover {
	border-color: #b6c2cf;
	box-shadow: 0 8px 18px rgba(31, 41, 55, 0.1);
	transform: translateY(-1px);
}
.product-card__body {
	padding: 10px;
}
.product-card__image-wrap {
	align-items: center;
	aspect-ratio: 1 / 1;
	background: #f8fafc;
	border: 1px solid #edf1f5;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	margin-bottom: 10px;
	overflow: hidden;
}
.image-preview {
	height: 86%;
	image-rendering: smooth;
	object-fit: contain;
	width: 86%;
}
.product-card__title {
	align-items: center;
	display: flex;
	justify-content: center;
	min-height: 42px;
	text-align: center;
}
.product-card__title-link {
	color: #1976d2 !important;
	display: -webkit-box;
	font-size: 0.9rem;
	font-weight: 600;
	line-height: 1.25;
	overflow: hidden;
	text-decoration: none;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}
.product-card__title-link:hover {
	color: #0d47a1 !important;
}
.product-card__stats {
	background: #fbfcfd;
	border: 1px solid #edf1f5;
	border-radius: 8px;
	display: grid;
	gap: 1px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	margin-top: 8px;
	overflow: hidden;
}
.product-card__stat {
	background: #ffffff;
	display: flex;
	flex-direction: column;
	min-width: 0;
	padding: 7px 8px;
}
.product-card__stat span,
.product-card__price span,
.product-card__cost span {
	color: #607d8b;
	font-size: 0.7rem;
	font-weight: 700;
	letter-spacing: 0;
	text-transform: uppercase;
}
.product-card__stat strong,
.product-card__price strong,
.product-card__cost strong {
	color: #263238;
	font-size: 0.86rem;
	font-weight: 700;
	line-height: 1.3;
	overflow-wrap: anywhere;
}
.product-card__prices {
	margin-top: 8px;
}
.product-card__price-row,
.product-card__cost-grid {
	display: grid;
	gap: 6px;
	grid-template-columns: repeat(3, minmax(0, 1fr));
}
.product-card__cost-grid {
	margin-top: 6px;
}
.product-card__price,
.product-card__cost {
	background: #f8fafc;
	border: 1px solid #edf1f5;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	min-width: 0;
	padding: 7px 8px;
}
.product-card__price strong {
	color: #c2410c;
}
.product-card__cost strong {
	color: #c2410c;
}
.product-card__actions {
	padding: 0 10px 10px;
}
.card-border {
	border: 1px solid lightgrey;
	border-radius: 5%;
}
.card-border:hover {
	box-shadow: 0px 2px 0px 0px lightgray;
}
</style>
